import type { GenerationModelKey } from '@malaberg/shared';
import { Select } from '@mantine/core';
import { useEffect } from 'react';
import { useBriefFormStore } from '../../state/brief-form-store';
import { useRuntimeStore } from '../../state/runtime-store';
import { generationModelOptions } from '../../utils/generation-models';

export function GenerationModelSelect() {
  const generationModelKey = useBriefFormStore((state) => state.generationModelKey);
  const setField = useBriefFormStore((state) => state.setField);
  const runtimeInfo = useRuntimeStore((state) => state.runtimeInfo);
  const refresh = useRuntimeStore((state) => state.refresh);

  useEffect(() => {
    if (!runtimeInfo) {
      void refresh();
    }
  }, [refresh, runtimeInfo]);

  const options = generationModelOptions(runtimeInfo);
  const data = options.map((option) => ({
    value: option.key,
    label: option.label,
    disabled: !option.available,
  }));

  return (
    <Select
      label="Model"
      data={data}
      value={generationModelKey}
      allowDeselect={false}
      checkIconPosition="right"
      onChange={(value) => {
        const selected = options.find((option) => option.key === value);
        if (!selected?.available) return;
        setField('generationModelKey', value as GenerationModelKey);
      }}
      data-testid="generation-model-select"
    />
  );
}
